import * as React from 'react';

import { createStackNavigator } from '@react-navigation/stack';
import AppHeader from '../components/AppHeader';
import { getScreenOptions } from './getScreenOptions';
import MessengerRoomListScreen from '../screens/messenger/MessengerRoomListScreen';
import MessengerRoomScreen from '../screens/messenger/MessengerRoomScreen';

export type MessengerParamList = {
  MessengerRoomList: undefined;
  MessengerRoom: {
    roomId: number;
  };
};

const MessengerStack = createStackNavigator<MessengerParamList>();

export default function MessengerNavigator() {
  return (
    <MessengerStack.Navigator
      initialRouteName='MessengerRoomList'
      screenOptions={({ route }) => ({
        ...getScreenOptions(route),
        header: () => <AppHeader />,
        headerShown: true,
        gestureEnabled: false
      })}
    >
      <MessengerStack.Screen
        name='MessengerRoomList'
        component={MessengerRoomListScreen}
      />
      <MessengerStack.Screen
        name='MessengerRoom'
        component={MessengerRoomScreen}
      />
    </MessengerStack.Navigator>
  );
}
